import { useState } from "react";
import { api, errorMessage } from "../lib/api";

const REASONS = ["Non è un'attività alimentare", "Attività chiusa", "Locale duplicato", "Non in target", "Altro"];

export const VenueExcludeForm = ({ venue, csrfToken, onBack, onExcluded }) => {
  const [choice, setChoice] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const reason = choice === "Altro" ? details.trim() : choice;
  const exclude = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try { await api.post(`/venues/${venue.id}/exclude`, { reason },
      { headers: { "X-CSRF-Token": csrfToken } }); onExcluded(); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <form onSubmit={exclude} className="venue-exclude-form" data-testid="venue-exclude-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="venue-exclude-back">‹ Scheda locale</button>
    <h2 className="sheet-title" data-testid="venue-exclude-title">ESCLUDI LOCALE</h2>
    <p className="venue-exclude-copy" data-testid="venue-exclude-copy">{venue.name} resterà consultabile in Locali → Storico, ma non comparirà tra le attività da lavorare né nelle prossime ricerche.</p>
    <div className="exclusion-reasons" role="group" aria-label="Motivo dell'esclusione">
      {REASONS.map((value, index) => <button key={value} type="button" className={choice === value ? "active" : ""}
        aria-pressed={choice === value} onClick={() => setChoice(value)} data-testid={`venue-exclude-reason-${index}`}>{value}</button>)}
    </div>
    {choice === "Altro" && <div className="form-field"><label htmlFor="venue-exclude-other">MOTIVO</label>
      <input id="venue-exclude-other" value={details} minLength={3} maxLength={200} required
        onChange={(e) => setDetails(e.target.value)} data-testid="venue-exclude-other" /></div>}
    {error && <p role="alert" className="form-error" data-testid="venue-exclude-error">{error}</p>}
    <button type="submit" disabled={busy || reason.length < 3} className="hud-button hud-danger"
      data-testid="venue-exclude-confirm">Sposta nello storico</button>
  </form>;
};